export default {
  title: 'Contacts',
};
